import sendLog from './sendLog';
import { parseResponse, getRequestBody, isIgnoreApi } from './parseResponse';
import AES from '@ali/aes-tracker';

function hookXHR() {
  if (typeof window.XMLHttpRequest !== 'function' || !window.addEventListener) return;
  var originXMLHttpRequest = window.XMLHttpRequest;
  var _originXMLHttpRequest = originXMLHttpRequest.prototype,
      originOpen = _originXMLHttpRequest.open,
      originSend = _originXMLHttpRequest.send,
      originSetRequestHeader = _originXMLHttpRequest.setRequestHeader;

  originXMLHttpRequest.prototype.open = function (method, url) {
    originOpen.apply(this, arguments);
    this._aesHook = {
      method: method,
      url: url
    };
  };

  originXMLHttpRequest.prototype.setRequestHeader = function (header, value) {
    originSetRequestHeader.apply(this, arguments);
    this._aesHook.headers || (this._aesHook.headers = {});
    this._aesHook.headers[header] = value;
  };

  originXMLHttpRequest.prototype.send = function (body) {
    originSend.apply(this, arguments);

    try {
      var _this$_aesHook = this._aesHook,
          url = _this$_aesHook.url,
          _this$_aesHook$method = _this$_aesHook.method,
          method = _this$_aesHook$method === void 0 ? 'GET' : _this$_aesHook$method,
          headers = _this$_aesHook.headers;
      delete this._aesHook; // url 可能是 URL 对象

      var original_url = url ? url.href || url : ''; // 跳过部分API

      if (isIgnoreApi(original_url)) {
        return;
      }

      var original_url_s = original_url.split('?'),
          xhr = this,
          status = 0,
          params = original_url_s[1],
          begin = new Date().getTime();
      url = original_url_s[0];
      var parsedBody;

      try {
        parsedBody = getRequestBody(body, method);
      } catch (ex) {}

      var onLoaded = function onLoaded() {
        status = xhr.status || status;
        var duration = new Date().getTime() - begin,
            // getResponseHeader只能拿到部分w3c认为安全的响应头(Cache-Control、Content-Language、Content-Type、Expires、Last-Modified、Pragma)，或者由业务在响应头里增加“Access-Control-Expose-Headers: x-eagleeye-id”
        traceId; // 获取鹰眼ID、contentType

        try {
          // 不判断浏览器会报Refused to get unsafe header "eagleeye-traceid"
          var resHeaders = xhr.getAllResponseHeaders();

          if (resHeaders.indexOf('eagleeye-traceid') !== -1) {
            traceId = xhr.getResponseHeader('eagleeye-traceid');
          } else if (resHeaders.indexOf('x-eagleeye-id') !== -1) {
            traceId = xhr.getResponseHeader('x-eagleeye-id');
          }
        } catch (ex) {} // 默认拿到的都是String，可以通过xhr.responseType修改
        // respnseType包括：arraybuffer、blob、document、json、text、ms-stream
        // responseType为空时，默认是 text
        // xhr.responseType：https://developer.mozilla.org/zh-CN/docs/Web/API/XMLHttpRequest/responseType


        var responseType = xhr.responseType || 'text'; // 对于response只处理 text 和 json，其它场景只记录响应类型

        var response;

        if (responseType === 'text' || responseType === 'json') {
          response = xhr.response;
        } else {
          response = Object.prototype.toString.call(xhr.response);
        }

        var res = parseResponse(response, status, {
          type: 'xhr',
          params: params,
          url: url
        });
        var config = AES.getConfig('plugin_api') || {}; // 请求失败 或者 没有关闭请求成功也发送 则上报

        if (!res.success || !config.disable_send_on_success) {
          sendLog({
            url: url,
            method: method,
            success: res.success,
            msg: res.msg,
            status: status,
            code: res.code,
            // 业务code
            duration: duration,
            traceId: traceId,
            params: params,
            headers: headers,
            body: parsedBody,
            response: response,
            rtype: 'xhr'
          });
        }
      }; // abort、timeout、loadend等时间Edge在79以上才支持
      // 支持的环境下未设置时xhr.onloadend返回 null


      if (xhr.onloadend !== undefined) {
        // 客户端主动Abort
        xhr.addEventListener('abort', function (e) {
          status = -2;
        }); // 客户端超时

        xhr.addEventListener('timeout', function (e) {
          status = -3;
        });
        xhr.addEventListener('loadend', onLoaded);
      } else {
        xhr.addEventListener('readystatechange', function () {
          if (xhr.readyState === 4) {
            onLoaded();
          }
        });
      }
    } catch (ex) {}
  };
}

;
export default hookXHR;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-api@1.1.12@@ali/aes-tracker-plugin-api/es/libs/hookXHR.js
// module id = null
// module chunks = 